module.exports = __webpack_public_path__ + "img/ax-mobile-default.b2992a6e.png";